// src/EditPost.js
import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal, Dropdown } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import Select from "react-select";
import axios from "axios";
import LinearProgress from "@mui/material/LinearProgress";
import JoditEditor from "jodit-react";
import EditorConfig from "./EditorConfig";

const EditPost = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [editingArticle, setEditingArticle] = useState(null);
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categoryOption, setCategoryOption] = useState([]);
    // const [magazineOption, setMagazineOption] = useState([{ value: "562FF5E4CB9AC181", label: "Paperboy" }]);
    const [magazineOption, setMagazineOption] = useState([]);
    const [article, setArticle] = useState(null);
    const newTagRef = useRef(null);
    const [statusOption, setStatusOption] = useState([
        { value: 1, label: "Draft" },
        { value: 2, label: "Published" },
        { value: 3, label: "Archived" },
    ]);
    const [showPreview, setShowPreview] = useState(false);
    const [additionalFields, setAdditionalFields] = useState([]);
    const [subcategories, setsubCategories] = useState([]);


    const editor = useRef(null);

    useEffect(() => {
        fetchArticle();
    }, [id]);

    // const fetchArticle = async () => {
    //     try {
    //         const response = await axios.post(BASE_URL + "API/apicall", {
    //             security_key: security_key,
    //             pk_ac_key: id,
    //             mode: "getArticle",
    //         });
    //         const output = response.data;

    //         if (output) {
    //             setArticle(output);
    //             const parsedFields = JSON.parse(output.additionalFields);
    //             const addArr = parsedFields.map((row) => ({
    //                 pk_as_key: row.pk_as_key,
    //                 fileType: row.file_type,
    //                 type: row.content_type,
    //                 value: row.content_type === "image/video" ? IMAGE_URL + row["file_name"] : row["as_content"],
    //             }));

    //             setAdditionalFields(addArr);

    //             // setFieldValue("additionalFields", addArr);
    //         }
    //     } catch (error) {
    //         console.log("getArticle Error:");
    //         console.log(error);
    //         toast.error("Error fetching article details.", { autoClose: 3000 });
    //     }
    // };

    // console.log("article", article);


    const fetchArticle = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key,
                pk_ac_key: id,
                mode: "getArticle",
            });
            const output = response.data;

            if (output) {
                setArticle(output);
                const parsedFields = JSON.parse(output.additionalFields);
                const addArr = parsedFields.map((row) => ({
                    pk_as_key: row.pk_as_key,
                    fileType: row.file_type,
                    type: row.content_type,
                    value:
                        row.content_type === "image/video"
                            ? IMAGE_URL + row["file_name"]
                            : row["as_content"],
                }));

                setAdditionalFields(addArr);
            }
        } catch (error) {
            console.log(error);
            toast.error("Error fetching article details.", { autoClose: 3000 });
        }
    };

    useEffect(() => {
        getAllCategory();
        getAllMagazine();
        getAllSubCategories();
    }, []);

    useEffect(() => {
        if (article && subcategories.length > 0) {
            const parsedSubs = JSON.parse(article.subcategories || "{}");
            const normalizedSubs = Object.fromEntries(
                Object.entries(parsedSubs).map(([k, v]) => [String(k), String(v)])
            );

            const parsedCats = JSON.parse(article.cat_keys || "[]").map(String);

            formik.setValues((prev) => ({
                ...prev,
                category: parsedCats,
                subcategories: normalizedSubs,
            }));
            console.log('normalizedSubs', normalizedSubs)
        }
    }, [article, subcategories]);


    const getAllSubCategories = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllSubCategory",
            });
            const output = response.data;

            if (output.length > 0) {
                setsubCategories(
                    output.map((option) => ({
                        value: option.pk_sub_cat_key,
                        label: option.subcat_name,
                        fk_cat_key: option.fk_cat_key
                    }))
                );
            }
        } catch (error) {
            console.error("Error fetching subcategories:", error);
        }
    };

    useEffect(() => {
        if (Object.keys(values.subcategories || {}).length && subcategories.length > 0) {
            const updatedSubs = {};

            Object.entries(values.subcategories).forEach(([catKey, subKey]) => {
                const exists = subcategories.some(
                    sub => sub.value === subKey && sub.fk_cat_key === catKey
                );
                if (exists) updatedSubs[catKey] = subKey;
            });

            setFieldValue("subcategories", updatedSubs);
        }
    }, [subcategories]);

    const getAllCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategoryOption(
                output.map((option) => ({
                    value: option.pk_cat_key,
                    label: option.cat_name,
                }))
            );
        }
    };

    const getAllMagazine = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMagForPost",
        });

        const output = response.data;

        if (output.length > 0) {
            setMagazineOption(
                output.map((option) => ({
                    value: option.pk_mag_key,
                    label: option.mag_name,
                }))
            );
        }
    };

    const initialValues = {
        pk_ac_key: article ? article.pk_ac_key : "",
        ac_name: article ? article.ac_name : "",
        ac_summary: article ? article.ac_summary : "",
        additionalFields: additionalFields,
        newFieldType: article ? article.newFieldType : "",
        tags: article?.tags ? JSON.parse(article.tags) : [],
        newTag: article?.newTag || "",
        status: article ? article.status : "",
        fk_mag_key: article ? article.fk_mag_key : "",
        category: article?.cat_keys ? JSON.parse(article.cat_keys) : [],
        subcategories: article?.subcategories ? JSON.parse(article.subcategories) : {},
        created_by: sessionStorage.getItem("pk_user_key"),
        updated_by: sessionStorage.getItem("pk_user_key"),
    };

    const validationSchema = Yup.object().shape({
        ac_name: Yup.string()
            .min(3, "Article Name must be at least 3 characters.")
            // .max(250, "Article Name must be at most 250 characters.")
            // .matches(
            //     /^[a-zA-Z-:;\s]+$/,
            //     "Article Name should only contain letters, spaces, hyphens, colons, and semicolons, and should not start or end with a space."
            // )
            // .matches(/^[a-zA-Z][a-zA-Z\s]*[a-zA-Z]$/, "Article Name should only contain letters and spaces, and should not start or end with a space.")
            .required("Article Name is required.")
            .test("unique-link", "Article Name is already existing in the database", async function (value) {
                if (!value) return true;
                return await checkArticleTitle(value);
            }),
        ac_summary: Yup.string()
            .min(90, "Article Summary must be at least 90 character.")
            // .max(250, "Article Summary must be at most 250 characters.")
            // .matches(/^[^\s].*[^\s]$/, "Summary should not have leading or trailing spaces.")
            .required("Article Summary is required."),

        additionalFields: Yup.array().of(
            Yup.object().shape({
                type: Yup.string().required("Field type is required."), // Ensure type is always specified
                value: Yup.string().when("type", {
                    is: (val) => val === "text" || val === "multimedia",
                    then: (schema) => schema.required("Content is required."),
                    otherwise: (schema) => schema.notRequired(),
                }),
                // file: Yup.mixed().when("type", {
                //     is: "image/video",
                //     then: (schema) => schema.required("A file is required for image or video."),

                //     otherwise: (schema) => schema.notRequired(),
                // }),
                // file: Yup.mixed().when("type", {
                //     is: "image/video",
                //     then: (schema) => schema.required("A file is required for image or video."),
                //     otherwise: (schema) => schema.notRequired(),
                // }),
            })
        ),
        tags: Yup.array()
            .of(
                Yup.string()
                    .matches(/^[a-zA-Z0-9\s]+$/, "Only letters and numbers are allowed")
                    .required("Tag is required")
            )
            .default([]),
        newTag: Yup.string()
            .when("tags", (tags, schema) => {
                const flattenedTags = tags.flat().filter((tag) => tag !== "");
                if (flattenedTags.length === 0) {
                    return schema.required("Tag is required.");
                }
                return schema.notRequired();
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Tag can only contain letters and numbers."),
        status: Yup.string().required("Status is required."),
        fk_mag_key: Yup.string().required("Magazine is required."),
        category: Yup.array()
            .of(Yup.string().required("Category is required."))
            .min(1, "At least one category must be selected.")
            .required("Category is required."),
        subcategories: Yup.object().test(
            "subcategory-per-category",
            "Each selected category must have a subcategory selected.",
            function (selectedSubs) {
                const { category } = this.parent;

                if (!category || category.length === 0) return true;

                return category.every((catId) => {
                    const sub = selectedSubs?.[String(catId)];

                    // Handle if sub is undefined, null, number, or empty string
                    if (sub === undefined || sub === null) return false;
                    if (typeof sub === "string") return sub.trim() !== "";
                    return Boolean(sub); // For numbers or truthy values
                });
            }
        ),



    });

    async function checkArticleTitle(ac_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkArticleTitle",
            pk_ac_key: id,
            ac_name: ac_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            if (formValues.tags.length === 0) {
                formik.setFieldError("tags", "Please add at least one tag before submitting the article.");
                return;
            }
            toast.dismiss();
            setIsSubmitting(true);

            const response = await axios.post(
                `${BASE_URL}API/apicall`,
                {
                    security_key,
                    mode: "updateArticle1",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                fetchArticle();
                // toast.success("Updated successfully!");
                // setTimeout(() => history("/admin/article-management"), 3000);

                toast.success("Updated successfully!", {
                    autoClose: 3000,
                });

                setTimeout(() => {
                    navigate("../article-management");
                }, 3000);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }

            setIsSubmitting(false);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    // const handleAddField = () => {
    //     const newField = {
    //         base_type: values.newFieldType,
    //         value: "",
    //         fileType: "", // Include this if you want to handle file types
    //     };

    //     setFieldValue("additionalFields", [...values.additionalFields, newField]);
    //     setFieldValue("newFieldType", ""); // Reset the new field type
    // };

    // const handleAddField = () => {
    //     if (values.newFieldType) {
    //         setFieldValue("additionalFields", [...values.additionalFields, { type: values.newFieldType, value: "", accept: "image/*,video/*" }]);
    //         setFieldValue("newFieldType", "");
    //     }
    // };

    const handleAddField = (fieldType) => {
        if (fieldType) {
            setFieldValue("additionalFields", [...values.additionalFields, { type: fieldType, value: "", accept: "image/*,video/*", isNew: true }]);
            setFieldValue("newFieldType", "");
        }
    };

    const handleRemoveField = (index) => {
        const updatedFields = values.additionalFields.filter((_, i) => i !== index);
        setFieldValue("additionalFields", updatedFields);
    };
    const handleAddTag = () => {
        if (values.newTag && !values.tags.flat().includes(values.newTag)) {
            setFieldValue("tags", [...values.tags.flat(), values.newTag]); // Flatten to avoid nested arrays
            setFieldValue("newTag", "");
            if (newTagRef.current) {
                newTagRef.current.focus();
                newTagRef.current.blur();
            }
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setFieldValue(
            "tags",
            values.tags.filter((tag) => tag !== tagToRemove)
        );
    };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const updatedFields = [...values.additionalFields];
            updatedFields[index] = {
                ...updatedFields[index],
                value: URL.createObjectURL(file),
                fileType: file.type,
                file: file,
                updated: 1,
            };
            setFieldValue("additionalFields", updatedFields);
        }
    };

    // const handleFileChange = (e, index) => {
    //     const file = e.target.files[0];
    //     const fileReader = new FileReader();

    //     fileReader.onloadend = () => {
    //         const updatedFields = [...values.additionalFields];
    //         updatedFields[index] = {
    //             ...updatedFields[index],
    //             value: fileReader.result,
    //             fileType: file.type,
    //             // updated: 1,
    //         };
    //         setFieldValue("additionalFields", updatedFields);
    //     };

    //     if (file) {
    //         fileReader.readAsDataURL(file);
    //     }
    // };

    const handlePreview = () => {
        setShowPreview(true); // Show the preview modal
    };

    const handleClosePreview = () => {
        setShowPreview(false); // Hide the preview modal
    };

    const handleContentChange = (e, content, index) => {
        const updatedFields = [...values.additionalFields];
        updatedFields[index].value = content === "<p><br></p>" ? "" : content;
        setFieldValue("additionalFields", updatedFields);
    }

    return (
        <>
            <ToastContainer position="top-center" />
            <div className="container mt-4 bg-white p-4 mb-3">
                <Form className="mb-3" onSubmit={handleSubmit} ref={formRef}>
                    <Form.Group className="d-flex justify-content-between mb-3">
                        <h4 className="mb-2">Edit Article</h4>
                        <div>
                            {/* <Button variant="outline-dark" className="me-2" onClick={handlePreview}>
                                Preview
                            </Button> */}

                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Save Article
                                {isSubmitting && <LinearProgress />}
                            </Button>
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>
                            Title <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control type="text" name="ac_name" value={values.ac_name} onChange={handleChange} onBlur={handleBlur} placeholder="Title" />
                        {errors.ac_name && touched.ac_name && <p className="text-danger">{errors.ac_name}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>
                            Summary <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            name="ac_summary"
                            value={values.ac_summary}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Summary"
                        />
                        {errors.ac_summary && touched.ac_summary && <p className="text-danger">{errors.ac_summary}</p>}
                    </Form.Group>

                    {/* Dynamic Created Inputs */}
                    {/* Dynamic Created Inputs */}
                    {/* {values.additionalFields.map((field, index) => (
                        <Form.Group key={index} className="mb-3">
                            {field.base_type === "text" && (
                                <>
                                    <Form.Control
                                        type="text"
                                        value={field.value}
                                        onChange={(e) => {
                                            const updatedFields = [...values.additionalFields];
                                            updatedFields[index].value = e.target.value;
                                            setFieldValue("additionalFields", updatedFields);
                                        }}
                                        placeholder="Text Box"
                                        isInvalid={!!errors.additionalFields?.[index]?.value && !!touched.additionalFields?.[index]?.value}
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <Form.Control.Feedback type="invalid">{errors.additionalFields[index].value}</Form.Control.Feedback>
                                    )}
                                </>
                            )}
                            {field.base_type === "multimedia" && (
                                <>
                                    <ReactQuill
                                        value={field.value}
                                        onChange={(content) => {
                                            const updatedFields = [...values.additionalFields];
                                            updatedFields[index].value = content === "<p><br></p>" ? "" : content;
                                            setFieldValue("additionalFields", updatedFields);
                                        }}
                                        modules={RichTextEditor.modules}
                                        formats={RichTextEditor.formats}
                                        placeholder="Multimedia"
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <p className="text-danger">{errors.additionalFields[index].value}</p>
                                    )}
                                </>
                            )}
                            {field.base_type === "image/video" && (
                                <>
                                    <label
                                        htmlFor={`additionalImage-${index}`}
                                        role="button"
                                        className="dropzone border p-4 rounded w-100 text-center"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <p>Drag 'n' drop an image or video here, or click to select one</p>

                                        {field.as_content &&
                                            (field.content_type.startsWith("image/") ? (
                                                <img
                                                    src={field.as_content}
                                                    alt="Additional"
                                                    style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "cover" }}
                                                />
                                            ) : field.content_type.startsWith("video/") ? (
                                                <video src={field.as_content} controls style={{ maxWidth: "100%", maxHeight: "200px" }} />
                                            ) : null)}
                                    </label>
                                    <input
                                        type="file"
                                        id={`additionalImage-${index}`}
                                        onChange={(e) => handleFileChange(e, index)}
                                        style={{ display: "none" }}
                                    />
                                    {errors.additionalFields?.[index]?.file && <p className="text-danger">{errors.additionalFields[index].file}</p>}
                                </>
                            )}
                            {field.base_type === "subtitle" && <h5>{field.value}</h5>}
                        </Form.Group>
                    ))} */}

                    {values.additionalFields.map((field, index) => (
                        <Form.Group key={index} className="mb-3 position-relative z-1">
                            {/* Render remove button only for newly added fields */}
                            {field.isNew && (
                                <Button
                                    variant="link"
                                    onClick={() => handleRemoveField(index)}
                                    className="position-absolute top-0 end-0 p-1"
                                    style={{ zIndex: 1, backgroundColor: "transparent" }}
                                >
                                    <span className="text-danger">×</span>
                                </Button>
                            )}

                            {field.type === "text" && (
                                <>
                                    <Form.Label>
                                        Sub Title <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={field.value}
                                        // onChange={(e) => {
                                        //     const updatedFields = [...values.additionalFields];
                                        //     updatedFields[index].value = e.target.value;
                                        //     setFieldValue("additionalFields", updatedFields);
                                        // }}
                                        onChange={(e) => {
                                            setFieldValue(`additionalFields[${index}].value`, e.target.value);
                                        }}
                                        placeholder="Text Box"
                                        isInvalid={!!errors.additionalFields?.[index]?.value && !!touched.additionalFields?.[index]?.value}
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <Form.Control.Feedback type="invalid">{errors.additionalFields[index].value}</Form.Control.Feedback>
                                    )}
                                </>
                            )}

                            {field.type === "multimedia" && (
                                <>
                                    <Form.Label>
                                        Content <span className="text-danger">*</span>
                                    </Form.Label>
                                    <JoditEditor
                                        ref={editor}
                                        config={EditorConfig}
                                        value={field.value}
                                        // onChange={(content) => {
                                        //     const updatedFields = [...values.additionalFields];
                                        //     updatedFields[index].value = content === "<p><br></p>" ? "" : content;
                                        //     setFieldValue("additionalFields", updatedFields);
                                        // }}
                                        onChange={(e, content) => {
                                            handleContentChange(e, content, index)
                                        }}

                                        // onChange={(content) => {
                                        //     setFieldValue(`additionalFields[${index}].value`, content === "<p><br></p>" ? "" : content);
                                        // }}
                                        modules={RichTextEditor.modules}
                                        formats={RichTextEditor.formats}
                                        placeholder="Multimedia"
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <p className="text-danger">{errors.additionalFields[index].value}</p>
                                    )}
                                </>
                            )}

                            {field.type === "image/video" && (
                                <>
                                    <Form.Label>
                                        Image/Video <span className="text-danger">*</span>
                                    </Form.Label>
                                    <label
                                        htmlFor={`additionalImage-${index}`}
                                        role="button"
                                        className="dropzone border p-4 rounded w-100 text-center"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <p>Drag 'n' drop an image or video here, or click to select one</p>

                                        {field.value &&
                                            (field.fileType ? (
                                                field.fileType.startsWith("image/") ? (
                                                    <img
                                                        src={field.value}
                                                        alt="Additional"
                                                        style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "cover" }}
                                                    />
                                                ) : field.fileType.startsWith("video/") ? (
                                                    <video src={field.value} controls style={{ maxWidth: "100%", maxHeight: "200px" }} />
                                                ) : null
                                            ) : null)}
                                    </label>
                                    <input
                                        type="file"
                                        id={`additionalImage-${index}`}
                                        onChange={(e) => handleFileChange(e, index)}
                                        style={{ display: "none" }}
                                        accept={field.accept}
                                    />
                                    {errors.additionalFields?.[index]?.file ? <p className="text-danger">{errors.additionalFields[index].file}</p> : null}
                                </>
                            )}

                            {field.type === "subtitle" && <h5>{field.value}</h5>}
                        </Form.Group>
                    ))}
                    {/* {values.additionalFields.map((field, index) => (
                        <Form.Group key={index} className="mb-3">
                            {field.type === "text" && (
                                <>
                                    <Form.Label>Sub Title <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={field.value}
                                        onChange={(e) => {
                                            const updatedFields = [...values.additionalFields];
                                            updatedFields[index].value = e.target.value;
                                            setFieldValue("additionalFields", updatedFields);
                                        }}
                                        placeholder="Text Box"
                                        isInvalid={!!errors.additionalFields?.[index]?.value && !!touched.additionalFields?.[index]?.value}
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <Form.Control.Feedback type="invalid">{errors.additionalFields[index].value}</Form.Control.Feedback>
                                    )}
                                </>
                            )}
                            {field.type === "multimedia" && (
                                <>
                                    <Form.Label>Content <span className="text-danger">*</span> </Form.Label>
                                    <ReactQuill
                                        value={field.value}
                                        onChange={(content) => {
                                            const updatedFields = [...values.additionalFields];
                                            console.log(content);
                                            if (content !== "<p><br></p>") {
                                                updatedFields[index].value = content;
                                            } else {
                                                updatedFields[index].value = "";
                                            }
                                            setFieldValue("additionalFields", updatedFields);
                                        }}
                                        modules={RichTextEditor.modules}
                                        formats={RichTextEditor.formats}
                                        placeholder="Multimedia"
                                    />
                                    {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                        <p className="text-danger">{errors.additionalFields[index].value}</p>
                                    )}
                                </>
                            )}
                            {field.type === "image/video" && (
                                <>
                                    <Form.Label>Image/Video <span className="text-danger">*</span> </Form.Label>
                                    <label
                                        htmlFor={`additionalImage-${index}`}
                                        role="button"
                                        className="dropzone border p-4 rounded w-100 text-center"
                                        style={{ cursor: "pointer" }}
                                    >
                                        {field.accept == "image/*" ? (
                                            <p>Drag 'n' drop an image, or click to select one</p>
                                        ) : (
                                            <p>Drag 'n' drop an image or video here, or click to select one</p>
                                        )}

                                        {field.value &&
                                            (field.fileType ? (
                                                field.fileType.startsWith("image/") ? (
                                                    <img
                                                        src={field.value}
                                                        alt="Additional"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "200px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                ) : field.fileType.startsWith("video/") ? (
                                                    <video
                                                        src={field.value}
                                                        controls
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "200px",
                                                        }}
                                                    />
                                                ) : null
                                            ) : null)}
                                    </label>
                                    <input
                                        type="file"
                                        id={`additionalImage-${index}`}
                                        onChange={(e) => handleFileChange(e, index)}
                                        style={{ display: "none" }}
                                        accept={field.accept}
                                    />
                                    {
                                        // (errors.additionalFields?.[index]?.fileType && touched.additionalFields?.[index]?.fileType) ||
                                        // errors.additionalFields?.[index]?.file && touched.additionalFields?.[index]?.file ? (
                                        //     <p className="text-danger">{errors.additionalFields[index].fileType || errors.additionalFields[index].file}</p>
                                        // ) : null
                                        errors.additionalFields?.[index]?.file ? (
                                            <p className="text-danger">{errors.additionalFields[index].fileType || errors.additionalFields[index].file}</p>
                                        ) : null
                                    }
                                </>
                            )}

                            {field.type === "subtitle" && <h5>{field.value}</h5>}
                        </Form.Group>
                    ))} */}

                    {/* Additional Fields Section */}
                    <div className="mb-3">
                        <div className="d-flex justify-content-end align-items-center gap-2">
                            <Dropdown>
                                <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                                    {values.newFieldType
                                        ? `Add ${values.newFieldType.charAt(0).toUpperCase() + values.newFieldType.slice(1)}`
                                        : "+ Add More Fields"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleAddField("text")}>Text Box</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAddField("multimedia")}>Multimedia</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAddField("image/video")}>Image/Video</Dropdown.Item>
                                </Dropdown.Menu>
                                {/* <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'text' to additionalFields
                                            setFieldValue("newFieldType", "text");
                                        }}
                                    >
                                        Text Box
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'multimedia' to additionalFields
                                            setFieldValue("newFieldType", "multimedia");
                                        }}
                                    >
                                        Multimedia
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'image/video' to additionalFields
                                            setFieldValue("newFieldType", "image/video");
                                        }}
                                    >
                                        Image/Video
                                    </Dropdown.Item>
                                </Dropdown.Menu> */}
                            </Dropdown>
                            {/* <Button variant="outline-dark" onClick={handleAddField}>
                                Add Field
                            </Button> */}
                        </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 flex-sm-wrap flex-md-nowrap">
                        <Form.Group controlId="status" className="w-50 w-sm-100">
                            <Form.Label>
                                Status <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={statusOption}
                                id="status"
                                name="status"
                                value={statusOption.find((option) => option.value && values.status && option.value.toString() === values.status.toString())}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "status",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, status: true });
                                }}
                            />

                            {errors.status && touched.status && <p className="text-danger">{errors.status}</p>}
                        </Form.Group>
                        <Form.Group controlId="category" className="w-50 w-sm-100">
                            <Form.Label>
                                Category <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={categoryOption}
                                id="category"
                                name="category"
                                value={categoryOption.filter((option) => (values.category || []).includes(option.value))}
                                isMulti
                                onChange={(selectedOptions) => {
                                    const event = {
                                        target: {
                                            name: "category",
                                            value: selectedOptions.map((option) => option.value),
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, category: true });
                                }}
                            />
                            {errors.category && touched.category && <p className="text-danger">{errors.category}</p>}
                        </Form.Group>

                        <Form.Group controlId="fk_mag_key" className="w-50 w-sm-100">
                            <Form.Label>
                                Magazine <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={magazineOption}
                                id="fk_mag_key"
                                name="fk_mag_key"
                                value={magazineOption.find(
                                    (option) => option.value && values.fk_mag_key && option.value.toString() === values.fk_mag_key.toString()
                                )}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "fk_mag_key",
                                            value: selectedOption ? selectedOption.value : "", // Handle if selectedOption is null or undefined
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, fk_mag_key: true });
                                }}
                            />
                            {errors.fk_mag_key && touched.fk_mag_key && <p className="text-danger">{errors.fk_mag_key}</p>}
                        </Form.Group>
                    </div>
                    {values.category.length > 0 && (
                        <div className="mb-3">
                            {values.category.map((catId) => {
                                // Get category details
                                const category = categoryOption.find((c) => c.value === catId);

                                // Get only subcategories for this category
                                const subOptions = subcategories
                                    .filter((s) => s.fk_cat_key === catId)
                                    .map((s) => ({ label: s.label, value: s.value }));

                                // 👇 Skip rendering if no subcategory available
                                if (subOptions.length === 0) return null;

                                return (
                                    <div
                                        key={catId}
                                        className="d-flex flex-column flex-md-row align-items-md-center mb-2"
                                    >
                                        <Form.Label className="me-md-3 mb-1 mb-md-0" style={{ minWidth: "150px" }}>
                                            {category?.label || "Category"} — Subcategory
                                            <span className="text-danger">*</span>
                                        </Form.Label>

                                        <div className="flex-grow-1">
                                            <Select
                                                options={subOptions}
                                                name={`subcategory-${catId}`}
                                                value={subOptions.find(
                                                    (opt) => opt.value === values.subcategories?.[catId]
                                                )}
                                                onChange={(selectedOption) => {
                                                    const event = {
                                                        target: {
                                                            name: "subcategories",
                                                            value: {
                                                                ...values.subcategories,
                                                                [catId]: selectedOption?.value || "",
                                                            },
                                                        },
                                                    };
                                                    handleChange(event);
                                                }}
                                                onBlur={() => {
                                                    handleBlur({ target: { name: "subcategories" } });
                                                    setTouched({ ...touched, subcategories: true });
                                                }}
                                            />
                                            {errors.subcategories &&
                                                touched.subcategories &&
                                                !values.subcategories?.[catId] && (
                                                    <p className="text-danger mt-1 mb-0">
                                                        Please select a subcategory for {category?.label}.
                                                    </p>
                                                )}
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Global error if validation fails */}
                            {errors.subcategories &&
                                touched.subcategories &&
                                typeof errors.subcategories === "string" && (
                                    <p className="text-danger">{errors.subcategories}</p>
                                )}
                        </div>
                    )}

                    <div className="mb-3 d-flex gap-2">
                        <Form.Group controlId="newTag" className="w-50 ">
                            <Form.Label>
                                Tag <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                ref={newTagRef}
                                value={values.newTag}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Add a tag"
                                className="form-control border"
                            />

                            {errors.newTag && touched.newTag && <p className="text-danger">{errors.newTag}</p>}
                            {errors.tags && touched.tags && <p className="text-danger">{errors.tags}</p>}
                        </Form.Group>

                        <div className="w-50">
                            <Button
                                variant="outline-dark"
                                onClick={handleAddTag}
                                id="addTagBtn"
                                className="p-0 p-1"
                                style={{ fontSize: "14px", marginTop: "30px" }}
                                disabled={!!errors.newTag && touched.newTag}
                            >
                                Add Tag
                            </Button>
                        </div>
                    </div>
                    {(values.tags || []).length > 0 && (
                        <div className="mb-3">
                            <h6>Tags:</h6>
                            {values.tags.map((tag) => (
                                // <span key={tag} className="badge bg-secondary me-2 position-relative" style={{ cursor: "pointer" }}>
                                //     {tag}
                                //     <span
                                //         className="position-absolute translate-middle"
                                //         style={{
                                //             color: "red",
                                //             top: "-3px",
                                //             end: "-3",
                                //             fontSize: "1rem",
                                //             cursor: "pointer",
                                //             padding: "0.2rem",
                                //             zIndex: 1,
                                //         }}
                                //         onClick={(e) => {
                                //             e.stopPropagation(); // Prevents triggering the parent onClick
                                //             handleRemoveTag(tag);
                                //         }}
                                //     >
                                //         ×
                                //     </span>
                                // </span>
                                <span key={tag} className="badge bg-secondary me-4 position-relative" style={{ cursor: "pointer" }}>
                                    {tag}
                                    <span
                                        className="position-absolute translate-middle"
                                        style={{
                                            color: "red",
                                            top: "7px",
                                            right: "-25px",
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                            padding: "0.2rem",
                                            zIndex: 1,
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveTag(tag);
                                        }}
                                    >
                                        ×
                                    </span>
                                </span>
                            ))}
                        </div>
                    )}
                </Form>

                {/* Preview Modal */}
                {/* <Modal show={showPreview} onHide={handleClosePreview} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Article Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "800px", overflowY: "scroll" }}>
            <h1 className="text-center">{values.ac_name}</h1>
            <h5>{values.ac_summary}</h5>

            {(values.additionalFields || []).map((field, index) => (
              <div key={index} className="mt-3">
                {field.type === "text" && <p>{field.value}</p>}
                {field.type === "multimedia" && <div dangerouslySetInnerHTML={{ __html: field.value }} />}
                {field.value &&
                  (field.fileType ? (
                    field.fileType.startsWith("image/") ? (
                      <div className="w-100 text-center">
                        <img
                          src={field.value}
                          alt="Additional"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "200px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ) : field.fileType.startsWith("video/") ? (
                      <div className="w-100 text-center">
                        <video
                          src={field.value}
                          controls
                          style={{
                            maxWidth: "100%",
                            maxHeight: "200px",
                          }}
                        />
                      </div>
                    ) : null
                  ) : null)}
                {field.type === "subtitle" && <h5>{field.value}</h5>}
              </div>
            ))}
            {values.tags.length > 0 && (
              <div className="mt-3">
                <h6>Tags:</h6>
                {values.tags.map((tag) => (
                  <span key={tag} className="badge bg-secondary me-2">
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClosePreview}>
              Close
            </Button>
          </Modal.Footer>
        </Modal> */}
            </div>
        </>
    );
};

const RichTextEditor = {
    modules: {
        toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            // ["link", "image"],
            ["clean"],
        ],
    },
    formats: ["header", "font", "list", "bullet", "bold", "italic", "underline", "align", "link", "image", "clean"],
};

export default EditPost;
